import { ControlledNumberInput } from '@sravni/cosago-react-library/lib/components';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';

import { useValidateOnBlur } from 'shared/lib/useValidateOnBlur';

export const InitialFee: FC<IFieldFactoryProps> = (props) => {
  const { type, ...other } = props;
  const validate = useValidateOnBlur(type);

  return (
    <ControlledNumberInput
      {...other}
      name={type}
      thousandSeparator=" "
      onBlur={validate}
    />
  );
};
